import { Text, Caption } from '@/shared/components/typography'

interface ParkinglotExtraInfoViewProps {
  options: string[] | []
}

const ParkinglotExtraInfoView = ({ options }: ParkinglotExtraInfoViewProps) => {
  return (
    <div className="h-full w-full">
      <Text level="text3" weight="bold" color="text090">
        추가 정보
      </Text>
      <div className="mt-[12px] flex flex-wrap items-center gap-[8px]">
        {options.map((text, i) => (
          <div key={i} className="h-full rounded-[34px] border border-[#DEE4E9] px-[12px] py-[6px]">
            <Caption level="caption2" weight="regular" color="text090">
              {text}
            </Caption>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ParkinglotExtraInfoView
